import firebase from '@firebase/app'
import * as firebaseui from 'firebaseui'

import '@firebase/auth'
import '@firebase/firestore'

export const firebaseApp = firebase.initializeApp({
	apiKey: 'AIzaSyBaRZaboFdDztwTz2A1YOwk1PD0aAo5voA',
	authDomain: 'stockup.davidanddacia.com',
	databaseURL: 'https://grocery-list-7ecd9.firebaseio.com',
	projectId: 'grocery-list-7ecd9',
	storageBucket: 'grocery-list-7ecd9.appspot.com',
	messagingSenderId: '630985706164',
})

export const auth = firebaseApp.auth!()
export const fs = firebaseApp.firestore!()

export const authUI = new firebaseui.auth.AuthUI(auth)

export interface Reference {
	$id: string
}

export type RootLevelCollection
	= '(brands+pantry-items)'
	| '(categories+lists)'
	| '(categories+pantry-items)'
	| '(households+users)'
	| 'brands'
	| 'categories'
	| 'coupons'
	| 'households'
	| 'lists'
	| 'pantry-items'
	| 'shopping-list-items'
	| 'users'
